import type { ReactNode } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { iconInfoCircle } from '#src/atoms/icons/system/iconInfoCircle.ts';
import { Tooltip } from '#src/atoms/tooltip/Tooltip/index.tsx';

const messages = defineMessages({
  label: {
    defaultMessage: 'More information',
  },
});

type Props = {
  title: NonNullable<ReactNode>;
};

export const FeeInfoTooltip = ({ title }: Props) => {
  const { formatMessage } = useIntl();

  return (
    <Tooltip placement="top" title={title}>
      <FontAwesomeIcon
        color="var(--c-nd-600)"
        icon={iconInfoCircle}
        title={formatMessage(messages.label)}
      />
    </Tooltip>
  );
};
